module.exports = __webpack_public_path__ + "img/carIcon.8a69d7ad.png";